'use client';

import { type ButtonProps, Button as MuiButton, styled } from '@mui/material';

const StyledButton = styled(MuiButton)({
  borderRadius: 20,
  whiteSpace: 'nowrap',
});

interface Props extends ButtonProps {
  loading?: boolean;
}

export default function Button({ loading, ...props }: Props) {
  return (
    <StyledButton
      loading={loading}
      {...props}
    />
  );
}
